import { ProductModel } from 'interfaces'

export const getProductKey = (product: ProductModel): string => {
  const key = `${product.lineCode}-${product.partNumber}`
  return key.replace(/[^\w-]/g, '_')
}
